module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hrFqm"))).then(() => parcelRequire('ljYL6'));